import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { CurrentBrandScope } from '../../app-state/current-brand';

@Component({
  selector: 'pr-patient-deposit-required-badge',
  templateUrl: './patient-deposit-required-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule],
  host: {
    class: 'flex',
  },
})
export class PatientDepositRequiredBadgeComponent {
  readonly depositsEnabled = toSignal(
    inject(CurrentBrandScope).depositsEnabled$,
    {
      initialValue: false,
    }
  );
  readonly depositRequired = input(false, { transform: coerceBooleanProperty });
}
